import type { AttendanceReviewListParams } from "@membentry/shared-types";

export const ATTENDANCE_REVIEW_QUERY_KEY = "attendance-review";
export const CLUB_DAILY_SUMMARY_QUERY_KEY = "club-daily-summary";

export const attendanceReviewQueryKey = (params: AttendanceReviewListParams = {}) =>
  [ATTENDANCE_REVIEW_QUERY_KEY, params.page ?? 0, params.pageSize ?? 20] as const;
